var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.booking.items_total)?_c('b-button',{attrs:{"variant":"outline-danger","disabled":_vm.waiting_for_pdf_receipt},on:{"click":_vm.export_receipt}},[(!_vm.waiting_for_pdf_receipt)?[_c('b-icon-file-pdf'),_vm._v(" View Receipt ")]:[_c('re-spinner',{attrs:{"variant":"danger"}})]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }